import { Component, inject, Input, WritableSignal } from '@angular/core';
import { Photo } from '@models/photo';
import { OverlayService } from '@services/overlay';
import { PhotoType } from 'src/app/types/photo.type';
import { PhotoHelpComponent } from '../photo-help/photo-help.component';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { RetakePhotoComponent } from '../retake-photo/retake-photo.component';
import { Session } from 'src/app/queries/generated';

@Component({
  selector: 'lv-session-retake-photo',
  templateUrl: './session-retake-photo.component.html',
  styleUrls: ['./session-retake-photo.component.scss'],
  imports: [PhotoHelpComponent, CloseOverlayKeyboardDirective, RetakePhotoComponent]
})
export class SessionRetakePhotoComponent {
  @Input() session!: Session;
  @Input() photo!: WritableSignal<Photo>;
  @Input() photoType!: PhotoType;

  private overlayService = inject(OverlayService);

  onPhotoTaken(photo: Photo) {
    this.photo.set(photo);
  }

  onPhotoAccepted() {
    this.overlayService.closeTopOverlay();
  }
}
